import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAvatar,
  setIsLoadingAvatar,
} from "../store/slices/session/sessionSlice";
import { selectUserDb } from "../store/slices/session/sessionSelector";
import { RootState } from "../store/rootReducers";
import { getUserImageUrl } from "../firebase/firebaseStorage";

export const useAvatar = () => {
  const dispatch = useDispatch();
  const userDb = useSelector(selectUserDb);
  const isLoadingAvatar = useSelector(
    (state: RootState) => state.session.isLoadingAvatar
  );

  useEffect(() => {
    const fetchAvatar = async () => {
      if (!userDb?.firebaseUid) {
        dispatch(setAvatar("")); // explicitly clear when no user
        return;
      }
      dispatch(setIsLoadingAvatar(true));
      try {
        const imageUrl = await getUserImageUrl(userDb.firebaseUid);
        if (imageUrl) {
          dispatch(setAvatar(imageUrl));
        } else {
          dispatch(setAvatar("")); // explicitly clear when no image found
        }
      } catch (error) {
        console.error("Error fetching avatar:", error);
      } finally {
        dispatch(setIsLoadingAvatar(false));
      }
    };

    fetchAvatar();
  }, [dispatch, userDb?.firebaseUid]);

  return { isLoading: isLoadingAvatar };
};
